export const ERROR_TITLE = 'errorPage.error.title';
export const ERROR_TEXT = 'errorPage.error.text';
